import { Box } from '@mantine/core';
import { useGetColor } from 'hooks';
import type { IconPropsType } from './types';

export const FormsIcon = ({
  color,
  size = 24,
  sx,
  ...props
}: IconPropsType) => {
  const iconColor = useGetColor(color);
  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="-3 -2 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.83333 11.6289C4.41912 11.6289 4.08333 11.9647 4.08333 12.3789C4.08333 12.7931 4.41912 13.1289 4.83333 13.1289V11.6289ZM7.11907 13.1289C7.53328 13.1289 7.86907 12.7931 7.86907 12.3789C7.86907 11.9647 7.53328 11.6289 7.11907 11.6289V13.1289ZM4.83333 8.07336C4.41912 8.07336 4.08333 8.40914 4.08333 8.82336C4.08333 9.23757 4.41912 9.57336 4.83333 9.57336V8.07336ZM10.1667 9.57336C10.5809 9.57336 10.9167 9.23757 10.9167 8.82336C10.9167 8.40914 10.5809 8.07336 10.1667 8.07336V9.57336ZM4.83333 13.1289H7.11907V11.6289H4.83333V13.1289ZM4.83333 9.57336H10.1667V8.07336H4.83333V9.57336ZM11.0588 2.81722H12.9706V1.31722H11.0588V2.81722ZM12.9706 2.81722C13.3634 2.81722 13.75 3.16548 13.75 3.68163H15.25C15.25 2.41455 14.2672 1.31722 12.9706 1.31722V2.81722ZM13.75 3.68163V15.3861H15.25V3.68163H13.75ZM13.75 15.3861C13.75 15.9023 13.3634 16.2505 12.9706 16.2505V17.7505C14.2672 17.7505 15.25 16.6533 15.25 15.3861H13.75ZM12.9706 16.2505H3.02941V17.7505H12.9706V16.2505ZM3.02941 16.2505C2.63665 16.2505 2.25 15.9023 2.25 15.3861H0.75C0.75 16.6533 1.73283 17.7505 3.02941 17.7505V16.2505ZM2.25 15.3861V3.68163H0.75V15.3861H2.25ZM2.25 3.68163C2.25 3.16549 2.63666 2.81722 3.02941 2.81722V1.31722C1.73282 1.31722 0.75 2.41454 0.75 3.68163H2.25ZM3.02941 2.81722H4.94118V1.31722H3.02941V2.81722ZM9.83333 0.250549H6.5V1.75055H9.83333V0.250549ZM6.5 0.250549C5.48864 0.250549 4.75 1.11023 4.75 2.06722H6.25C6.25 1.84599 6.40679 1.75055 6.5 1.75055V0.250549ZM4.75 2.06722C4.75 3.0242 5.48864 3.88388 6.5 3.88388V2.38388C6.40679 2.38388 6.25 2.28844 6.25 2.06722H4.75ZM6.5 3.88388H9.83333V2.38388H6.5V3.88388ZM9.83333 3.88388C10.8447 3.88388 11.5833 3.02422 11.5833 2.06722H10.0833C10.0833 2.28843 9.92654 2.38388 9.83333 2.38388V3.88388ZM11.5833 2.06722C11.5833 1.11022 10.8447 0.250549 9.83333 0.250549V1.75055C9.92654 1.75055 10.0833 1.846 10.0833 2.06722H11.5833Z"
        fill={iconColor}
      />
    </Box>
  );
};
